import {
  deletePushDevice,
  getPushSettings,
  registerPushDevice,
  sendTestPush,
  type PushDevice,
  type PushSettings,
  type PushTestResult,
  type RegisterPushDeviceBody,
} from '@nucleus-commerce/api-client/admin';

/**
 * The signed-in member's web push devices (LC16). Registering is idempotent on the browser's
 * endpoint, so the admin re-registers on every load to keep the keys fresh and learn the row id.
 */
export const pushApi = {
  settings: (): Promise<PushSettings> => getPushSettings(),
  register: (body: RegisterPushDeviceBody): Promise<PushDevice> => registerPushDevice(body),
  remove: (id: string): Promise<void> => deletePushDevice({ id }),
  test: (): Promise<PushTestResult> => sendTestPush(),
};
